import React from 'react'

const Webinars: React.FC = () => {

  return (
    <div className="min-h-screen py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6">
            Webinars
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join our healthcare technology webinars and educational events.
          </p>
        </div>
        
        <div className="mt-16 text-center">
          <p className="text-lg text-gray-600">
            This page is under development. More content coming soon.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Webinars


